import React, { useMemo } from "react";
import Layout from "../../layout/Layout";
import RFPMain from "../../templates/rfp/Main";
import { runway } from "../../utils/keywords";

const RFPRunwayPage = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext;
  return (
    <Layout crumbs={crumbs} crumbLabel={"RFP"}>
      <RFPMain keyword={runway} />
    </Layout>
  );
};

export default RFPRunwayPage;
